export const defaultColumns = [
  { label: 'Status', value: 'status' },
  { label: 'Cod. Fatura', value: 'number' },
  { label: 'Estabelecimento', value: 'establishment_info' },
  { label: 'Faturamento', value: 'consumed_total' },
  { label: 'Vlr. Taxa', value: 'fee_total' },
  { label: 'Vlr. Líquido', value: 'total_amount' },
  { label: 'Data de abertura', value: 'opened_at' },
  { label: 'Data de fechamento', value: 'closed_at' },
  { label: 'Data de pagamento', value: 'due_at' },
  { label: 'Ações', value: 'actions', className: 'w-0' },
]
